import { LegalLayout, Section } from "@/components/LegalLayout";
import { usePageMeta } from "@/utils/pageMeta";

const Terms = () => {
  usePageMeta("Conditions générales d'utilisation — ActiPilote", "Conditions générales d'utilisation du site actipilote.com et de la plateforme ActiPilote.");

  return (
    <LegalLayout eyebrow="Légal" title="Conditions générales d'utilisation" updated="septembre 2026" testid="terms-page">
      <Section title="1. Objet">
        <p>Les présentes conditions régissent l'utilisation du site actipilote.com, site de présentation de la plateforme de gestion ActiPilote destinée aux professionnels des activités touristiques et de loisirs.</p>
      </Section>
      <Section title="2. Éditeur du site">
        <p>Le site est édité par <span className="font-semibold text-navy">FULL AGENCY</span> — EURL au capital social de 1 000,00 €, dont le siège social est situé 68 rue de la Croix de l'Orme, 78630 Morainvilliers, France — SIRET : 978 641 348 00047.</p>
        <p>Contact : <a href="mailto:contact@actipilote.com" className="font-semibold text-brand hover:underline">contact@actipilote.com</a></p>
      </Section>
      <Section title="3. Accès au site">
        <p>Le site est accessible gratuitement à tout utilisateur disposant d'un accès à Internet. L'accès à la plateforme applicative (app.actipilote.com) est réservé aux clients disposant d'un compte actif.</p>
      </Section>
      <Section title="4. Propriété intellectuelle">
        <p>L'ensemble des éléments du site (marque ActiPilote, logo, textes, visuels, interface) est protégé. Toute reproduction ou réutilisation sans autorisation écrite préalable est interdite.</p>
      </Section>
      <Section title="5. Responsabilité">
        <p>Les informations présentées sur ce site le sont à titre indicatif. L'éditeur s'efforce d'en garantir l'exactitude sans pouvoir en assurer l'exhaustivité. Le site peut contenir des liens vers des sites tiers dont l'éditeur n'est pas responsable.</p>
      </Section>
      <Section title="6. Droit applicable">
        <p>Les présentes conditions sont soumises au droit français. En cas de litige, et après tentative de résolution amiable, les tribunaux français seront seuls compétents.</p>
      </Section>
    </LegalLayout>
  );
};

export default Terms;
